<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo main__logo__title">
        <img src="../../assets/images/logo/logo.svg" alt="">
        <h2 class="brand-text ml-1 title">
          Enterprise<br>
          <span class="title_go">GoDigital</span>
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Forgot password V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Forgot password-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title class="mb-1">
            Forgot Password? 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Enter your email and we'll send you instructions to reset your password
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
            <b-form-group
                label="Company Id"
                label-for="forgot-password-CompanyID"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Company Id"
                  rules="required"
                >
                  <b-form-input
                    id="forgot-password-CompanyID"
                    v-model="companyid"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-CompanyID"
                    placeholder="Company Id"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                label="Email"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="forgot-password-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button
                type="submit"
                variant="primary"
                block
              >
                Send reset link
              </b-button>
            </b-form>
          </validation-observer>

          <p class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </p>
        </b-col>
      </b-col>
      <!-- /Forgot password-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BCardTitle, BCardText, BImg, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from "@/api/api-v1-anonym";

export default {
  components: {
    VuexyLogo,
    BRow,
    BCol,
    BLink,
    BImg,
    BForm,
    BButton,
    BFormGroup,
    BFormInput,
    BCardTitle,
    BCardText,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      companyid: '',
      sideImg: require('@/assets/images/pages/forgot-password-v2.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/forgot-password-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    async validationForm() {
      let success = await this.$refs.simpleRules.validate();
      if (success) {

        try{
          const payload = {
          email: this.userEmail,
        };
        const headers = {
          headers: {
            tenant: this.companyid,
          },
        };
        console.log("🚀 ~ validationForm ~ headers:", headers)
        const response = await api.post(`/users/forgot-password`, payload, headers);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'A link has been sent to your mail',
              icon: 'EditIcon',
              variant: 'success',
            },
          })

          setTimeout(() => this.$router.push({ name: 'auth-login'}), 800);
        } catch {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'An error has occured. Please contact support!',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        }
        
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.main__logo__title .title{
  color: #4065ab;
  font-weight: 700;
}
.main__logo__title .title_go{
  color: #b0cc48;
  font-weight: 700;
}

.main__logo__title img{
  width: 60px;
  height: auto;
}

</style>
